import moment from 'moment';
import { uuid } from 'uuidv4';
import renderAvailabilities from "./renderAvailabilities";

const setUpSchedule = (availabilityStore, firstMatch) => {
  const initTs = {
    duration: availabilityStore.schedule !== null ? availabilityStore.schedule.duration : 60,
    id: uuid(),
    time: {
      start: availabilityStore.schedule ? moment(availabilityStore.schedule.startTime).unix() * 1000 : moment(new Date()).unix() * 1000,
      end: availabilityStore.schedule ? moment(availabilityStore.schedule.endTime).unix() * 1000 : moment(new Date()).unix() * 1000
    },
    drafts: []
  };
  const result = {
    availabilities: [...renderAvailabilities(availabilityStore)],
    timeslots: availabilityStore.schedule !== null && availabilityStore.schedule.canceled !== true ? [initTs] : [],
    drafts: [],
    raw: {
      group: []
    }
  };
  const clientMap = result.availabilities.filter(({
    type
  }) => type === 'client').map(avail => {
    return {
      start: avail.time.start,
      end: avail.time.end
    };
  });
  const expertMap = result.availabilities.filter(({
    type
  }) => type === 'expert').map(avail => {
    return {
      start: avail.time.start,
      end: avail.time.end
    };
  });
  let obj = {
    onSelectDate: null,
    handleFirstMatch: null,
    result: null
  };

  if (result.timeslots.length) {
    obj.onSelectDate = result.timeslots[0].time.start;
  } else if (firstMatch > 0) {
    obj.onSelectDate = result.timeslots[0].time.start;
    obj.handleFirstMatch = firstMatch;
  } else if (clientMap.length) {
    obj.onSelectDate = clientMap[0].start;
  } else if (expertMap.length) {
    obj.onSelectDate = expertMap[0].start;
  }

  obj.result = result;
  return obj;
};

export default setUpSchedule;